import { allTrackers } from "app/services/track/track";

function createListsTrackingService(track: (category: string, action: string, event: string) => void) {
    return {
        trackCompanyContactsClick(companyName: string, count: number) {
            track("Table", "click", `Contacts/${companyName}/${count}`);
        },
        trackActionsPrepareForMeetingClick() {
            track("company options", "click", "prepare for a meeting");
        },
        trackActionsAiOutreachClick() {
            track("company options", "click", "craft an email");
        },
        trackActionsExportClick() {
            track("company options", "click", "export company");
        },
        trackActionsDDClick() {
            track("company options", "click", "Open drop down");
        },
        trackTagCellDDClick() {
            track("tag", "open", "Open drop down");
        },
        trackTagCellItemSelect(value: string, companyName: string) {
            track("tag", "click", `${value}//${companyName}`);
        },
        trackTagCellAddItem(value: string, companyName: string) {
            track("tag", "click", `${value}/custom/${companyName}`);
        },
        trackAssignHookClick() {
            track("sales intelligence hooks", "click", "Assign hook");
        },
        trackRemoveHookClick() {
            track("sales intelligence hooks", "click", "Remove from list hook");
        },
        trackMoveToListHookClick() {
            track("sales intelligence hooks", "click", "Move to list hook");
        },
        trackCreateNewListHookClick() {
            track("sales intelligence hooks", "click", "Create new list hook");
        },
    };
}

export default createListsTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));
